<template>
  <div class="support-and-assistance">
    <card-six class="support-card" />
  </div>
</template>

<script>
import CardSix from '../../components/cards/card-6.vue';
import HeaderTitleTwo from '../../components/typography/header-title-2.vue';

export default {
  components: {
    CardSix,
  },
};
</script>

<style lang="scss" scoped>
.support-and-assistance {
  width: 100%;
  &-card {
    margin-top: 24px !important;
  }
}
</style>
